"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.b = exports.a = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _chunk6104512b = require("./chunk-6104512b.js");

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reactHtmlAttributes = ["children", "href", "to", "src", "target", "rel", "id", "className", "placeholder", "type", "value", "alt", "aria-label", "title", "exact", "onFocus", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "onChange", "onInput", "onInvalid", "onSubmit", "onClick", "onContextMenu", "onDoubleClick", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp", "onSelect", "onScroll", "disabled"];
var splitAttributes = [].concat(reactHtmlAttributes, (0, _chunkB2edacfb.k)(_chunk6104512b.b));

var getPropValueByToken = function getPropValueByToken(theme, propValue) {
  return propValue && propValue[0] && propValue[0] === "$" ? theme[propValue] : propValue;
};

var Box = (0, _styledComponents.withTheme)(function (_ref) {
  var theme = _ref.theme,
      props = (0, _chunkB2edacfb.j)(_ref, ["theme"]);
  var matchedProps = (0, _chunk6104512b.c)(props, splitAttributes).matchedProps;
  var replacedProps = Object.keys(matchedProps).reduce(function (sum, curr) {
    return (0, _chunkB2edacfb.i)({}, sum, (0, _chunkB2edacfb.h)({}, curr, getPropValueByToken(theme, matchedProps[curr])));
  }, {});
  return _react.default.createElement(_chunk6104512b.a, (0, _chunkB2edacfb.g)({}, replacedProps, {
    is: props.is
  }));
});
exports.a = Box;
Box.propTypes = _chunk6104512b.a.propTypes;
Box.defaultProps = _chunk6104512b.a.defaultProps;
Box.displayName = "Box";

var Flex = function Flex(props) {
  return _react.default.createElement(Box, props);
};

exports.b = Flex;
Flex.propTypes = Box.propTypes;
Flex.defaultProps = (0, _chunkB2edacfb.i)({}, Box.defaultProps, {
  display: "flex"
});
Flex.displayName = "Flex";
Flex.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Flex",
  "props": {
    "display": {
      "defaultValue": {
        "value": "\"flex\"",
        "computed": false
      },
      "required": false
    }
  },
  "composes": ["../Box/Box"]
};
Flex.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Flex",
  "composes": ["styled-components"]
};